import { FormattedMessage, useIntl } from "react-intl";

import { RanaModal } from "@nens/ranalib";

import { usePublicationStore } from "../../../store/store";
import { CompleteFile } from "../../../types/file-reference-with-file";

export const FileRemoveConfirmationModal = ({
  onClose,
  files,
}: {
  onClose: () => void;
  files: CompleteFile[];
}) => {
  const intl = useIntl();
  const removeFileByPath = usePublicationStore((store) => store.removeFileByPath);

  return (
    <RanaModal
      isOpen
      onClose={onClose}
      topBar={intl.formatMessage({
        id: "publication.are_you_sure",
        defaultMessage: "Are you sure?",
      })}
      maxW="xl"
      buttons={[
        {
          variant: "secondary",
          onClick: onClose,
          children: intl.formatMessage({ id: "no", defaultMessage: "No" }),
        },
        {
          variant: "danger",
          onClick: () => {
            files.forEach((file) => removeFileByPath(file.file.id));
            onClose();
          },
          children: intl.formatMessage({
            id: "yes",
            defaultMessage: "Yes",
          }),
        },
      ]}
    >
      {files.length ? (
        <FormattedMessage
          id="publication.remove_file_confirmation"
          defaultMessage="At least one of the files is being used in a layer of the viewer. If you remove them, these layers will also be removed. Do you want to proceed?"
        />
      ) : (
        <FormattedMessage
          id="publication.remove_file_confirmation"
          defaultMessage="This file is being used in layers of the viewer. If you remove it, these layers will also be removed. Do you want to proceed?"
        />
      )}
    </RanaModal>
  );
};
